import React, { useEffect, useState, Fragment, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import md5 from 'md5';
import ReCAPTCHA from 'react-google-recaptcha';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { putData } from '../services/fetch-service';
import { setPaymentResponse } from './store/dataslice';
import { LoadingOverlay, Loader } from '@mantine/core';

const customLoader = (
    <div className="payment-load">
        <Loader color="#006" />
        <span>Në procesim...</span>
    </div>
);

const PayseraPayment = () => {
    const [checkoutApp, setCheckoutApp] = useState(null);
    const [updateLoader, setUpdateLoader] = useState(false);
    const location = useLocation();
    const dispatch = useDispatch();
    const reCaptchaRef = useRef(null);

    const PaymentResponse = useSelector((state) => state.Website.data.PaymentResponse);

    // console.log('PaymentResponse', PaymentResponse)

    const ProjectId = process.env.REACT_APP_PROJECT_ID;
    const SignPassword = process.env.REACT_APP_SIGN_PASSWORD;
    const accepturl = process.env.REACT_APP_ACCEPT_URL;
    const cancelurl = process.env.REACT_APP_CANCEL_URL;
    const callbackurl = process.env.REACT_APP_CALLBACK_URL;
    const version = process.env.REACT_APP_PAYSERA_VERSION;
    const test = process.env.REACT_APP_PAYSERA_TEST;
    const frame = process.env.REACT_APP_PAYSERA_FRAME;

    const [urlSign, setUrlSign] = useState(null);
    const [urlDataParams, setUrlDataParams] = useState(null);
    const [urlDataDecoded, setUrlDataDecoded] = useState(null);
    const [urlData, setUrlData] = useState(null);
    const [urlDataJson, setUrlDataJson] = useState(null);

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(location.search);
        const dataParam = urlSearchParams.get('data');
        const ss1Param = urlSearchParams.get('ss1');
        if (dataParam) {
            setUrlDataParams(dataParam);
        }
        if (ss1Param) {
            setUrlSign(ss1Param)
        }
    }, [location.search]);

    useEffect(() => {
        if (urlDataParams) {
            const dataCallback = urlDataParams.replace(/\_/g, '/').replace(/\-/g, '+');
            setUrlDataDecoded(atob(dataCallback));
        }
    }, [urlDataParams]);

    useEffect(() => {
        if (urlDataDecoded) {
            const data = decodeURIComponent(urlDataDecoded);
            setUrlData(data);
        }
    }, [urlDataDecoded]);

    useEffect(() => {
        if (urlData) {
            const urlSearchParams = new URLSearchParams(urlData);
            const urlDataObject = {};

            for (const [key, value] of urlSearchParams) {
                urlDataObject[key] = value;
            }

            setUrlDataJson(urlDataObject);
        }
    }, [urlData]);

    const putUpdatePagesaPerSherbime = async (data) => {
        reCaptchaRef.current.reset();
        try {
            setUpdateLoader(true);
            const token = await reCaptchaRef.current.executeAsync();
            const dataWithToken = {
                ...data,
                token: token
            }
            // const response = await putData('Pagesat/UpdatePagesaPerSherbime', dataWithToken);
            // if (response && response.status === 200) {
            //     setUpdateLoader(false);
            //     setAlertMessage(<Alert severity="success">Pagesa është kryer me sukses!</Alert>);
            //     dispatch(setPaymentResponse(null));
            // }
        } catch (error) {
            setUpdateLoader(false);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: `${error.response ? error.response.data.modelState.Error.errors[0].errorMessage : "Pagesa dështoi!"}`
            });
            dispatch(setPaymentResponse(null));
        }
    }

    useEffect(() => {
        if (urlDataJson && urlSign && PaymentResponse) {

            const values = {
                id: PaymentResponse.id,
                idtransaction: PaymentResponse.idTransaction,
                onlinePaymentMethod: urlDataJson.payment,
                onlinePaymentStatus: urlDataJson.status
            }

            putUpdatePagesaPerSherbime(values);
        }
    }, [urlDataJson, urlSign]);

    useEffect(() => {
        setCheckoutApp(new window.PayseraCheckout.App());
    }, []);

    useEffect(() => {
        if (!checkoutApp) return;

        checkoutApp.on(window.PayseraCheckout.AppEvent.SUCCESS, () => {
            alert('Payment Successful!');
        });

        checkoutApp.on(window.PayseraCheckout.AppEvent.ERROR, (message) => {
            console.error('Paysera Checkout Error:', message);

            switch (message.code) {
                case window.PayseraCheckout.ErrorCode.USER_CLOSED:
                    break;

                case window.PayseraCheckout.ErrorCode.CARD_INITIAL_RESULT_FAILED:
                    break;

                case window.PayseraCheckout.ErrorCode.CARD_AUTHORIZATION_FAILED:
                    break;

                case window.PayseraCheckout.ErrorCode.CARD_RESULT_FAILED:
                    break;

                case window.PayseraCheckout.ErrorCode.CARD_SIGNATURE_FAILED:
                    break;

                default:
                    break;
            }

            alert('Payment Error. Please try again.');
        });

        return () => {
        };
    }, [checkoutApp]);

    const generateSignature = (data) => {
        const urlEncodedData = new URLSearchParams(data).toString();
        const base64EncodedData = btoa(urlEncodedData);
        const data64 = base64EncodedData.replace(/\//g, '_').replace(/\+/g, '-');

        const sign = md5(data64 + '8745ee52c2c5b3ddaa3b1365cf92b3c1');
        return sign;
    };

    const generateData64 = (data) => {
        const urlEncodedData = new URLSearchParams(data).toString();
        const base64EncodedData = btoa(urlEncodedData);
        const data64 = base64EncodedData.replace(/\//g, '_').replace(/\+/g, '-');

        const sign = data64;
        return sign;
    };

    useEffect(() => {
        if (PaymentResponse) {
            handlePayButton();
        }
    }, [PaymentResponse])

    // console.log('PaymentResponse', PaymentResponse)

    const parameters = {
        projectid: `${ProjectId}`,
        amount: PaymentResponse && (PaymentResponse.strVleraTotale.replace(/,/g, '') * 100),
        sign_password: `${SignPassword}`,
        p_firstname: PaymentResponse && PaymentResponse.emri,
        p_lastname: PaymentResponse && PaymentResponse.mbiemri,
        p_email: PaymentResponse && PaymentResponse.email,
        p_street: PaymentResponse && PaymentResponse.paguesiAdresa,
        currency: 'EUR',
        orderid: PaymentResponse && PaymentResponse.idTransaction,
        country: 'XK',
        lang: 'ALB',
        version: `${version}`,
        paytext: `Pagesa me numër: [order_nr] për institucionin: ${PaymentResponse && PaymentResponse.institucioniEmertimi}, në [owner_name] ([site_name])`,
        accepturl: accepturl,
        cancelurl: cancelurl,
        callbackurl: callbackurl
    };
    
    const handlePayButton = async () => {
        try {
            if (!checkoutApp) {
                console.error('Paysera Checkout is not initialized');
                return;
            }

            const dataParams = {
                ...parameters,
                test: test,
                frame: frame,
            };

            const data = generateData64(dataParams);
            const sign = generateSignature(dataParams);

            const paymentWindow = window.open('', '_self');
            paymentWindow.location.href = `https://bank.paysera.com/pay?data=${data}&sign=${sign}`;
        } catch (error) {
            console.error('Error generating signature:', error);
        }
    };

    //  veq me paysera
    // const handlePayButtonClick4 = async () => {
    //     try {
    //         if (!checkoutApp) {
    //             console.error('Paysera Checkout is not initialized');
    //             return;
    //         }

    //         const dataParams = {
    //             ...parameters,
    //             test: 1,
    //             frame: 0,
    //             payment: 'wallet',
    //         };

    //         const data = generateData64(dataParams);
    //         const sign = generateSignature(dataParams);

    //         const paymentWindow = window.open('', '_self');
    //         paymentWindow.location.href = `https://bank.paysera.com/pay?data=${data}&sign=${sign}`;
    //         // checkoutApp.pay({
    //         //   data: data,
    //         //   sign: sign,
    //         // });
    //     } catch (error) {
    //         console.error('Error generating signature:', error);
    //     }
    // };

    return (
        <Fragment>
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY}
                size="invisible"
                ref={reCaptchaRef}
            />
            <LoadingOverlay loader={customLoader} visible={updateLoader} />
        </Fragment>
    )
};

export default PayseraPayment
